// eslint-disable-line no-unused-vars
// eslint-disable-next-line no-unused-vars
export function isPermittedAction(action,role) {
    const actionToRole = {
        'editInventory' : [
          'pharmacy-editor',
          'Pharmacy',
        ],
    };

    if (actionToRole[action]==null){
        return true;
    } else if (actionToRole[action].includes(role)){
        return true;
    }
    return false;
}

export function isDefaultView(path) {
    const defaultRoutes = [
        '/auth/login',
        '/auth/passwort/anfordern',
        '/auth/passwort/zuruecksetzen',
    ];

    return defaultRoutes.includes(path);
}

export function isPermittedView(path,role) {
    const pathToRole = {
        '/crm/' : [
          'pharmacy-editor',
          'Pharmacy',
        ],
    };

    if (pathToRole[path]==null) {
        return true;
    } else if (pathToRole[path].includes(role)) {
        return true;
    }
    return false;
}

export function isPermitted(role) {
    const permittedRoles = [
        'pharmacy-user',
        'Pharmacy',
        'Administrator'
    ];

    return permittedRoles.includes(role);
}

export function isLoggedIn(user) {
    if (user == null || typeof user == 'undefined') {
        return false;
    } else {
        const keys = Object.keys(user);
        try {
            keys.forEach((key)=>{
                if (user[key].trim() === '') {
                    throw false;
                }
            });
        } catch(e) {
            return false;
        }

        const auth_token = localStorage.getItem("crm_auth_token");
        return (user.hasOwnProperty('userid') && auth_token!=null && auth_token.trim() !== '');
    }
}

export async function mapRoles(roles,role) {
    const roleObj = roles.filter(function(item){
        return item.id === role;
    });

    return roleObj.length === 1 ? roleObj[0].name : '';
}
